import { useState } from "react";
import { Reveal } from "./Reveal";
import {
  ArrowUpRight,
  Plus,
  Minus,
  Landmark,
  TrendingUp,
  Wallet,
  Wheat,
  ShieldPlus,
} from "lucide-react";

const services = [
  {
    icon: Landmark,
    title: "Intermediación Crediticia y SOFOMES",
    body: "Estructuración de créditos comerciales, arrendamiento financiero y factoraje para dotar de capital de trabajo inmediato a las empresas sin burocracia.",
  },
  {
    icon: TrendingUp,
    title: "Gestión de Fondos y Sociedades de Inversión",
    body: "Operación de fondos de capitales, fideicomisos de desarrollo y sociedades valuadoras para maximizar los rendimientos de excedentes corporativos con total transparencia.",
  },
  {
    icon: Wallet,
    title: "Dispersión de Dinero y Administración de Pensiones",
    body: "Soluciones tecnológicas para transmisores de fondos (pagadores y dispersores) y administración especializada de cajas de pensión y seguros independientes.",
  },
  {
    icon: Wheat,
    title: "Financiamiento Popular y Rural",
    body: "Impulso al sector agropecuario y comercial mediante financieras rurales, sociedades financieras populares (SOFIPOS) y esquemas comunitarios de ahorro y crédito.",
  },
  {
    icon: ShieldPlus,
    title: "Compañías Afianzadoras y Autofinanciamiento",
    body: "Provisión de garantías líquidas a través de afianzadoras y diseño de sistemas de autofinanciamiento comercial para la adquisición programada de activos fijos.",
  },
];

export const Servicios = () => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section
      id="servicios"
      data-testid="servicios-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-20">
          <div className="col-span-12 md:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3 text-[#017766] mb-6">
                <span className="h-px w-10 bg-[#017766]" />
                <span className="overline">Servicios</span>
              </div>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl md:text-6xl leading-[1.04] text-[#17351D]">
                Cartera de <em className="text-[#017766]">servicios</em>.
              </h2>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-5 flex md:items-end">
            <Reveal delay={0.1}>
              <p className="text-base md:text-lg text-[#17351D]/65 leading-relaxed">
                Un portafolio integral diseñado para resolver las necesidades de
                liquidez, inversión y estructuración financiera de empresas,
                bufetes y notarías.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="border-t border-[#17351D]/10">
          {services.map((s, i) => {
            const isOpen = openIdx === i;
            const Icon = s.icon;
            return (
              <Reveal key={s.title} delay={i * 0.04}>
                <div
                  data-testid={`service-row-${i}`}
                  className="service-row border-b border-[#17351D]/10"
                >
                  <button
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-8 md:py-10 pl-6 md:pl-10 pr-4 md:pr-6 text-left"
                    data-testid={`service-toggle-${i}`}
                  >
                    <div className="flex items-center gap-6 md:gap-8 flex-1 min-w-0">
                      <span className="w-12 h-12 md:w-14 md:h-14 border border-[#17351D]/15 flex items-center justify-center text-[#17351D] shrink-0">
                        <Icon size={22} strokeWidth={1.6} />
                      </span>
                      <h3 className="font-display text-2xl md:text-4xl text-[#17351D] leading-tight truncate">
                        {s.title}
                      </h3>
                    </div>
                    <span className="w-11 h-11 rounded-full border border-[#17351D]/15 flex items-center justify-center text-[#17351D] shrink-0">
                      {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-[max-height,opacity] duration-700 ease-out ${
                      isOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="pb-10 md:pb-14 pl-6 md:pl-[104px] pr-6 md:pr-10">
                      <div className="border-t border-[#17351D]/10 pt-6 max-w-3xl">
                        <p className="text-base md:text-[17px] text-[#17351D]/75 leading-relaxed">
                          {s.body}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-16 md:mt-24 flex flex-col md:flex-row md:items-center md:justify-between gap-8 bg-[#F7F6F1] p-8 md:p-12">
            <div>
              <div className="overline text-[#017766] mb-3">¿Necesita asesoría?</div>
              <h3 className="font-display text-2xl md:text-4xl text-[#17351D] leading-tight max-w-2xl">
                Diseñamos una estrategia a la medida de su despacho o empresa.
              </h3>
            </div>
            <button
              data-testid="services-cta-contact"
              onClick={() =>
                document
                  .getElementById("contacto")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="btn-primary bg-[#17351D] text-white font-semibold text-[12px] tracking-[0.22em] uppercase px-8 py-5 inline-flex items-center gap-3 self-start md:self-auto"
            >
              Hablemos
              <ArrowUpRight size={16} strokeWidth={2.2} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Servicios;
